<div class="ki-anforderung-tools">
  <app-ki-abdeckung
    [projectId]="projectId()"
    [requirementId]="requirementId()"
    [anfId]="anfId()"
    [anfTitel]="anfTitel()"
    [sperrgrund]="sperrgrund()"
    [entwurfGesperrt]="vorschlagState() !== 'aktiv'"
    [ungespeichert]="verknuepfungenUngespeichert()"
    [speichern]="speichernFuerPruefung()"
    [darfVerknuepfen]="darfVerknuepfen()"
    (entwurfErstellen)="entwurfAusAbdeckung($event)"
    (verknuepft)="abdeckungVerknuepfungGemeldet($event)"
  />
  <app-ki-button
    funktion="TESTDESIGN"
    [state]="vorschlagState()"
    [sperrgrund]="sperrgrund()"
    [label]="'ki.anforderungTools.testfaelleVorschlagen' | translate"
    (ausloesen)="vorschlagen()"
  />
</div>

@if (dialogOffen()) {
  <app-ki-testfall-vorschlag-dialog
    [kontext]="kontext()"
    [kriterium]="kriteriumText()"
    [(hinweis)]="hinweisEntwurf"
    (erzeugen)="erzeugen($event)"
    (abgebrochen)="dialogOffen.set(false)"
  />
}

@if (run.hinweis(); as verbindung) {
  <app-ki-erste-nutzung
    [verbindung]="verbindung"
    (verstanden)="run.hinweisVerstanden()"
    (abgebrochen)="run.hinweisAbgebrochen()"
  />
}

@if (panelSichtbar()) {
  <app-ki-panel
    [titel]="'ki.entwuerfe.titel' | translate"
    [kontext]="
      hinweis() ? ('ki.entwuerfe.kontextMitHinweis' | translate: { kontext: kontext(), hinweis: hinweis() }) : kontext()
    "
    (geschlossen)="panelOffen.set(false)"
  >
    @if (run.zustand().art === 'laeuft') {
      <app-ki-laeuft [aktion]="'ki.entwuerfe.laeuft' | translate" />
    }
    @if (fehlerKey(); as textKey) {
      <app-ki-fehler [text]="textKey | translate" (erneut)="run.erneut()" />
    }
    @if (fertigeAnfrage()) {
      @if (ansicht(); as ansicht) {
        <div class="ki-anforderung-tools__entwuerfe">
          @if (ansicht.ausgelassen > 0) {
            <div class="ki-anforderung-tools__ausgelassen" data-testid="ki-ausgelassen">
              <mat-icon class="ki-anforderung-tools__ausgelassen-icon" aria-hidden="true">check</mat-icon>
              <span class="ki-anforderung-tools__ausgelassen-text">
                {{
                  (ansicht.ausgelassen === 1 ? 'ki.entwuerfe.ausgelassenEins' : 'ki.entwuerfe.ausgelassen')
                    | translate: { anzahl: ansicht.ausgelassen }
                }}
              </span>
            </div>
          }
          @for (entwurf of ansicht.entwuerfe; track entwurf.entwurfId) {
            <app-ki-entwurf-card
              [entwurf]="entwurf"
              [projectId]="projectId()"
              [requirementId]="requirementId() ?? ''"
              [anfrageId]="ansicht.anfrageId"
              [anfId]="anfId()"
              [stand]="staende()[entwurf.entwurfId] ?? 'offen'"
              (standChange)="standGeaendert(entwurf, $event)"
              (angelegt)="angelegt(entwurf, $event)"
            />
          } @empty {
            <div class="ki-anforderung-tools__leer" data-testid="ki-entwuerfe-leer">
              {{ 'ki.entwuerfe.leer' | translate }}
            </div>
          }
          @if (gesendet(); as gesendet) {
            <app-ki-gesendet [gesendet]="gesendet" />
          }
        </div>
      } @else {
        <app-ki-ergebnis-abgelaufen />
      }
    }
    @if (gesamt() > 0) {
      <span kiPanelFuss class="ki-anforderung-tools__fuss" data-testid="ki-entwuerfe-fuss">
        {{ 'ki.entwuerfe.fuss' | translate: { offen: offen(), gesamt: gesamt() } }}
      </span>
    }
  </app-ki-panel>
}
